import Enum from "./enum";

export default class GatewayExternalIdentType extends Enum {
  id: string;
  externalGatewayIdent: string;
  description: string;
}
